import { expected, isUndefined } from '@aloft/toolkit-shared';

import { useActiveReferenceBarID } from '../../../controller/hooks/useActiveReferenceBarID.ts';
import { useTkv2ReferenceBarUserInterface } from '../../../controller/hooks/useTkv2ReferenceBarUserInterface.ts';
import { MapCoords, MapData } from '../hooks/useMapCoords.ts';
import { parseReferenceViewID } from '../referenceViewID/parseReferenceViewID.ts';

export const useActiveProperty = (mapData: MapCoords): MapData | undefined => {
  const { inPairedSales } = useTkv2ReferenceBarUserInterface();
  const activeID = useActiveReferenceBarID();

  if (mapData.isLoading || inPairedSales) return undefined;

  const parsed = parseReferenceViewID(activeID);
  if (isUndefined(parsed)) return undefined;

  // Check for kind-discriminated unions instead of 'type' property
  if ('subject' in parsed && parsed.subject === true) {
    return mapData.results.subject;
  }

  if ('compID' in parsed && parsed.compID) {
    return mapData.results[expected(parsed.compID)];
  }

  return undefined;
};
